import { lazy } from 'react';

const list = lazy(() => import('./List'));
const edit = lazy(() => import('./Edit'));
const create = lazy(() => import('./Create'));

export { list, edit, create };
